import {PageSection} from '../../../components';
import styled from 'styled-components';

export default styled(PageSection)`
  margin-bottom: 1em;
`;


// WEBPACK FOOTER //
// ./src/modules/record/components/FormPageSection.js